var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighResolutionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_110",
    "data-name": "Group 110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138.995,
    height: 140.632,
    viewBox: "0 0 138.995 140.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 138.995,
    height: 140.632,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M69.085.91A68.639,68.639,0,1,1,.488,69.551,68.62,68.62,0,0,1,69.085.91",
    transform: "translate(1.31 2.443)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M68.6,0A68.639,68.639,0,1,1,0,68.638,68.619,68.619,0,0,1,68.6,0",
    transform: "translate(0 0)",
    fill: "#1a1818",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M8.957,13.293v50.3a1.668,1.668,0,0,0,.623,1.456,2.152,2.152,0,0,0,1.456.77H78.062a2.33,2.33,0,0,0,2.075-2.078V13.293a2.33,2.33,0,0,0-2.075-2.075H11.035a2.334,2.334,0,0,0-2.078,2.075M13.7,47.272V19.082c0-1.445-.387-3.118,1.039-3.118H74.351A.919.919,0,0,1,75.391,17V60.181a2.133,2.133,0,0,1-.147.741c-.91.214-6.611.376-7.322-.092a1.821,1.821,0,0,1-.542-.645c-4.039-5.808-8.542-11.777-12.54-17.57-2.624-3.807-1.551-3.748-6.054,2.517-1.1,1.529-1.636,1.647-.833,2.738l3.777,5.273c.678.94,1.268,1.725,1.924,2.675s1.231,1.78,1.909,2.69L57,60.516c.431.892-.918.556-3.556.556-.962,0-1.419-1.047-1.887-1.677-3.4-4.544-7.1-10-10.51-14.711-1.194-1.655-11.3-16.185-12.072-16.7-.638.424-6.187,8.052-7.529,9.677-.343.416-.586.748-.9,1.176-.346.464-.619.77-.977,1.249l-4.724,6.106c-.343.468-.538.918-1.142,1.08",
    transform: "translate(24.05 30.12)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M21.835,20.4v1.187c0,3.18,3.35,6.53,6.526,6.53A6.826,6.826,0,0,0,33.318,26.7a7.015,7.015,0,0,0,2.311-3.029c2.414-5.358-3.191-11.855-9.349-9.353a7.044,7.044,0,0,0-2.963,2.229A6.955,6.955,0,0,0,21.835,20.4",
    transform: "translate(58.628 36.956)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighResolutionIcon);
export default __webpack_public_path__ + "static/media/high-resolution-icon.1245a1f7f6f4d4c0435b2fc97405bf90.svg";
export { ForwardRef as ReactComponent };